import { AxiosRequestConfig } from "axios";
import { httpService } from "./HttpServices";
import { ApiResponse } from "../utils/APIResponse";

export interface SystemConfig {
  maintenanceMode: boolean;
  maintenanceMessage: string;
  updatedAt: string;
  logoURL: string;
}

export class SystemConfigService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = "/health";
  }

  async getSystemConfig(
    config?: AxiosRequestConfig
  ): Promise<{ data: SystemConfig; message: string }> {
    try {
      const response = await httpService.get<ApiResponse<SystemConfig>>(
        `${this.baseUrl}/system-status`,
        config
      );

      return {
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      console.error("Error fetching organization overview:", error);
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to fetch organization overview.";
      throw new Error(errorMessage);
    }
  }
}

export const systemConfigService = new SystemConfigService();
